<template>
	<div class="container">
		<div class="back">
			<img src="/assets/CompanyLogo/logo2.png" alt class="back-img" />
		</div>
		<div class="main">
			<ul class="imp">
				<div class="footer-title">{{ $t('footer.links') }}</div>
				<div class="imp-main footer-list">
					<div>
						<router-link to="/">{{ $t('links.home') }}</router-link>
					</div>
					<div>
						<router-link :to="{ name: 'all-series' }">{{ $t('links.series') }}</router-link>
					</div>
					<div>
						<router-link :to="{ name: 'all-news' }">{{ $t('links.news') }}</router-link>
					</div>
					<div>
						<router-link :to="{ name: 'publishing-rules' }">{{ $t('links.rules') }}</router-link>
					</div>
					<div>
						<router-link :to="{ name: 'editorial-board' }">{{
							$t('links.editorial')
						}}</router-link>
					</div>
					<div>
						<router-link :to="{ name: 'join-us' }">{{ $t('links.join-us') }}</router-link>
					</div>
					<div>
						<router-link :to="{ name: 'about-us' }">{{ $t('links.about') }}</router-link>
					</div>
					<div>
						<router-link :to="{ name: 'contant' }">{{ $t('links.contact') }}</router-link>
					</div>
				</div>
			</ul>
			<ul class="ser">
				<div class="footer-title">{{ $t('series') }}</div>
				<div class="ser-main footer-list">
					<div v-for="serie in series.slice(0, 9)" :key="serie">
						<router-link
							:to="{
								name: 'serie',
								params: { id: serie.id, name: serie.name.replaceSpace() },
							}"
							>{{ serie.name }}</router-link
						>
					</div>
				</div>
			</ul>
			<ul class="con">
				<div class="footer-title">{{ $t('footer.contact') }}</div>
				<div class="con-main footer-list" dir="auto">
					<div>
						<i class="fas fa-phone"></i>
						<a href="tel:0212663132">021-266 3132</a>
					</div>
					<div>
						<i class="fas fa-fax"></i>
						<a href="fax:0212643832">021-264 3832</a>
					</div>
					<div>
						<i class="fas fa-envelope" style="margin-top: 3px"></i>
						<a href="mailto:rs1journal@alepuniv.edu.sy">rs1journal@alepuniv.edu.sy</a>
					</div>
					<div>
						<i class="fas fa-envelope" style="margin-top: 3px"></i>
						<a href="mailto:alepuniv.rja@gmail.com">alepuniv.rja@gmail.com</a>
					</div>
				</div>
			</ul>
		</div>
		<div class="contact">
			<div class="logo">
				<img src="/assets/CompanyLogo/logo.png" alt />
			</div>
			<div class="copy">
				<div class="c">{{ $t('footer.rights') }} @ {{ new Date().getFullYear() }}</div>
				<a href="https://www.beetronix.com" target="_blank" class="b">BEETRONIX</a>
			</div>
			<div class="social">
				<a
					href="https://www.facebook.com/%D9%85%D8%AC%D9%84%D8%A9-%D8%A8%D8%AD%D9%88%D8%AB-%D8%AC%D8%A7%D9%85%D8%B9%D8%A9-%D8%AD%D9%84%D8%A8-207291042768690/"
					target="_blank"
					><i class="fab fa-facebook-f"></i
				></a>
				<!-- <i class="fab fa-twitter"></i>
				<i class="fab fa-instagram"></i>
				<i class="fab fa-linkedin-in"></i> -->
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState({
			series: (state) => state.series.series,
		}),
	},
};
</script>

<style scoped>
* {
	color: white;
}
.container {
	direction: rtl;
	position: relative;
	overflow: hidden;
}
.container .main,
.container .contact {
	max-width: 1400px;
	margin: auto;
}
.back {
	background: var(--grey-color);
	height: 100%;
	width: 100%;
	bottom: 0;
	left: 0;
	height: 100%;
	z-index: -2;
	position: absolute;
	margin: 0 !important;
}
.back-img {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 200%;
	z-index: -1;
	filter: invert(100);
}
.container > div {
	margin-right: 70px;
	margin-left: 70px;
}
.footer-title {
	color: var(--yellow-color);
	text-align: center;
	font-family: changeBold;
	line-height: 40px;
	border-bottom: 2px solid #696969;
}
.main {
	display: flex;
	justify-content: space-between;
}
@media (min-width: 992px) {
	.main {
		padding-right: 2rem;
	}
}
.main ul {
	margin: 0;
}
.main ul:first-child {
	padding-right: 0;
}
.footer-list {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	padding: 20px 0;
}
.footer-list div {
	font-size: 12px;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 44px;
	line-height: 14px;
}
.imp {
	max-width: 300px;
}
.ser {
	max-width: 520px;
}
.con-main {
	grid-template-columns: 1fr;
}
.con-main div {
	width: 150px;
}
.con-main div svg {
	margin: 0 10px;
	float: right;
	filter: brightness(100);
	height: 10px;
}
.con-main > div {
	height: 33px !important;
}
.contact {
	display: flex;
	border-top: 2px solid #696969;
	justify-content: space-between;
	align-items: center;
	padding: 5px 0;
	padding-right: 2rem;
}
.logo img {
	height: 50px;
}
.copy {
	text-align: center;
	padding-right: 125px;
}
.c {
	font-size: 10px;
}
.b {
	font-size: 10px;
	line-height: 23px;
	font-weight: 900;
	font-family: Arial, Helvetica, sans-serif;
}
.social {
	width: max-content;
}
.social svg {
	padding: 12px;
	height: 40px;
	width: 40px;
	filter: invert(100%);
}
.social svg:hover {
	cursor: pointer;
	transition: transform 0.2s;
	transform: scale(1.3);
}
@media only screen and (max-width: 992px) {
	.container > div {
		margin: 0 10px;
		position: relative;
	}
	.back {
		position: absolute !important;
	}
	.back-img {
		width: 40%;
		height: auto;
	}
	.main {
		flex-direction: column;
	}
	.imp {
		max-width: unset;
	}
	.ser {
		max-width: unset;
	}
	.main ul {
		padding: 0;
		margin: auto;
		width: 80% !important;
	}
	.main ul:first-child {
		width: 360px;
	}
	.main ul:last-child {
		width: auto;
	}
	.imp-main {
		column-gap: 10px;
	}
	.imp-main div {
		height: 44px;
		line-height: 14px;
	}
	/* .ser-main {
    grid-template-columns: 1fr 1fr;
    column-gap: 30px;
  } */
	.main .con {
		width: 160px !important;
		margin: auto;
	}
	.con-main div svg {
		margin: 0 10px;
		float: none;
	}
}
@media only screen and (max-width: 767px) {
	.back-img {
		width: 100%;
	}
	.ser-main {
		grid-template-columns: 1fr 1fr;
		column-gap: 30px;
	}
	.ser-main div:last-child {
		grid-column-start: 1;
		grid-column-end: 3;
	}
	.con {
		margin-bottom: 30px !important;
	}
	.social {
		position: absolute;
		bottom: 60px;
		left: 50%;
		transform: translateX(-50%);
	}
	.contact {
		padding: 5px 20px;
	}
}
@media only screen and (max-width: 575px) {
	.imp-main {
		grid-template-columns: 1fr 1fr;
	}
}
</style>
